//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ModifyName",
  data() {
    return {};
  },
  props: {
    dialogNameVisible: {
      type: Boolean,
      default: () => true,
    },
    ruleForm: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close() {
      this.$emit("close", "dialogNameVisible");
    },
    /**
     * @descripttion: 修改角色名称
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditRoleName(item) {
      this.ruleForm.id = item.id;
      this.ruleForm.roleName = item.roleName;
      this.ruleForm.roleRemark = item.roleRemark;
      this.dialogNameVisible = true;
    },
    /**
     * @descripttion: 保存修改的名称
     * @Author: juanjuanhui
     * @Date: 2022-01-19 01:19:40
     * @param {*}
     * @return {*}
     */
    handleSaveRoleName() {
      if (!this.ruleForm.roleName) {
        this.$message({
          message: "请输入角色名称",
          type: "warning",
        });
        return;
      }
      this.$http.role
        .updateSRole({ ...this.ruleForm, systemType: this.systemType })
        .then((res) => {
          // this.getRoleList();
          if (res.status == 1) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.close();
            this.$emit("getRoleList");
          }
        });
    },
  },
  created() {},
  mounted() {},
};
